import { redirect } from 'vike/abort';

import { isIosNative } from '@/renderer/utils/isIosNative';

/**
 * `/cfb-results` is a web-checkout funnel: the promo archive renders "Get CFB
 * picks" order CTAs (linking to `/order/cfb`) inside its template. On iOS that
 * would violate App Store Review Guideline 3.1.1 (digital purchases must use
 * Apple's In-App Purchase), so we send iOS users to their content. Android + web
 * keep the normal funnel.
 *
 * Mirrors `pages/(marketing)/vsin/+guard.ts` and `pages/order/+guard.ts`: the
 * CTAs live inside the template's isolated <iframe> srcdoc, so React-level
 * `isIosNative()` hiding can't reach them; guarding the whole route off on iOS
 * is the only reliable gate. Runs on client-side navigation where
 * window.Capacitor is available; on server / web it evaluates false and does
 * nothing.
 */
export function guard(_pageContext: Vike.PageContext) {
  if (isIosNative()) {
    throw redirect('/release-center');
  }
}
